module.exports = __webpack_public_path__ + "img/story7.8466a142.jpeg";